import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Header({ dark = false }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  function handleLogout() {
    logout();
    setMenuOpen(false);
    navigate("/");
  }

  return (
    <header
      className={[
        "w-full lg:h-[70px] h-[64px] fixed top-0 z-50 transition-colors duration-300",
        scrolled || dark ? "bg-white text-black shadow-sm" : "bg-transparent text-white",
      ].join(" ")}
    >
      <div className="lg:py-3 py-2.5 md:px-[30px] max-w-screen-xl mx-auto px-[60px] w-full flex flex-row items-center">
        {/* Logo */}
        <div
          className={[
            "flex flex-col items-center cursor-pointer transition-opacity duration-300",
            scrolled || dark ? "opacity-100" : "opacity-0 pointer-events-none",
          ].join(" ")}
          onClick={() => navigate("/")}
        >
          <div className="font-bold text-[25px]">ODK</div>
        </div>

        {/* Menu */}
        <div className="ml-auto relative" ref={menuRef}>
          <button
            className="flex flex-col justify-center gap-[5px] w-[28px] cursor-pointer"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className={["block h-[2px] rounded transition-all duration-300",
              scrolled || dark ? "bg-black" : "bg-white"].join(" ")} />
            <span className={["block h-[2px] rounded transition-all duration-300",
              scrolled || dark ? "bg-black" : "bg-white"].join(" ")} />
            <span className={["block h-[2px] rounded transition-all duration-300",
              scrolled || dark ? "bg-black" : "bg-white"].join(" ")} />
          </button>

          {/* Dropdown */}
          {menuOpen && (
            <div className="absolute right-0 top-[calc(100%+12px)] w-[200px] bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">

              {user ? (
                <>
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-[13px] font-semibold text-gray-800 m-0 truncate">{user.email}</p>
                  </div>
                  <MenuItem onClick={() => { navigate("/cart"); setMenuOpen(false); }}>🛒 Cart</MenuItem>
                  <MenuItem onClick={() => { navigate("/orders"); setMenuOpen(false); }}>📋 My Bookings</MenuItem>
                  <div className="border-t border-gray-100">
                    <MenuItem onClick={handleLogout} danger>Sign Out</MenuItem>
                  </div>
                </>
              ) : (
                <>
                  <div className="border-t border-gray-100">
                    <MenuItem onClick={() => { navigate("/login"); setMenuOpen(false); }}>Sign In</MenuItem>
                    <MenuItem onClick={() => { navigate("/signup"); setMenuOpen(false); }}>Sign Up</MenuItem>
                  </div>
                </>
              )}

            </div>
          )}
        </div>
      </div>
    </header>
  );
}

function MenuItem({ onClick, children, danger = false }) {
  return (
    <button
      onClick={onClick}
      className={[
        "w-full text-left px-4 py-3 text-[14px] transition-colors hover:bg-gray-50",
        danger ? "text-red-400" : "text-gray-700",
      ].join(" ")}
    >
      {children}
    </button>
  );
}